<template>
  <div>
    <div class="m-b">
      <template v-if="showPrice">
        总报价（含税）：<span style="color: #FF8B26">{{ row.quotePrice }}元</span> 计算规则：报价清单含税总价之和
      </template>
      <p v-if="fileId && row.quote" style="display: flex;">
        <span>供应商的报价文件：</span>
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <zs-upload style="flex: 1" drag :multiple="false" :isDisabled="true"  v-model="fileId"> </zs-upload>
        <!-- <zsFileDownload :fileId="fileId"/> -->
      </p>
    </div>
    <zl-server-page-table
      :api="getApi"
      :border="false"
      height="390px"
      v-if="loaded"
      smallPagination
      paginationLayout="total, sizes, prev, pager, next, jumper"
    >
      <template v-for="(row, index) in listColumns">
        <el-table-column
          v-if="
            showPrice ||
              row.columnNameEN !== 'taxCombPrice' &&
              row.columnNameEN !== 'noTaxUnitPrice' &&
              row.columnNameEN !== 'noTaxCombPrice' &&
              row.columnNameEN !== 'taxUnitPrice'
          "
          :key="index"
          :label="row.columnNameCH"
          :prop="row.columnNameEN"
        >
        </el-table-column>
      </template>
    </zl-server-page-table>
  </div>
</template>

<script>
import store from '@/store'
// import zsFileDownload from '@/components/zsFileDownload'
import zsUpload from '@/components/zsUpload'
export default {
  components: {
    // zsFileDownload
    zsUpload
  },
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    fileId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      listColumns: [],
      totalAmount: 0
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      store
        .dispatch('getXdColumnBySypplier', {
          inquireId: this.row.inquireId
        })
        .then((res) => {
          this.listColumns = JSON.parse(res.colValue || '[]')
          this.loaded = true
        })
    },
    getApi(args) {
      return store
        .dispatch('pageZSBjInventory', {
          pageNum: args.page,
          pageSize: args.size,
          unionId: this.row.id
        })
        .then((res) => ({
          rows: res.list.map((t) => {
            let row = (t.rowValue && JSON.parse(t.rowValue)) || {}
            row.id = t.id
            return row
          }),
          total: res.totalCount
        }))
    }
  }
}
</script>

<style></style>
